import { render, staticRenderFns } from "./settlement-settings.vue?vue&type=template&id=4bb7707f&scoped=true"
import script from "./settlement-settings.vue?vue&type=script&lang=js"
export * from "./settlement-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7707f",
  null
  
)

export default component.exports